import { render, staticRenderFns } from "./GraficoMovimentacoesEstoqueProduto.vue?vue&type=template&id=9d8cf2b6"
import script from "./GraficoMovimentacoesEstoqueProduto.vue?vue&type=script&setup=true&lang=js"
export * from "./GraficoMovimentacoesEstoqueProduto.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports